import React from "react"
import styled from "styled-components/macro"
import { CircularProgress } from "@material-ui/core"
import * as Adm from "@adm"
import * as IconsGallery from "@iconsGallery"
function Spinner() {
  return <Adm.BrandLoadingBar />
}
export default Spinner
